const ToggleButton = {
  MuiToggleButtonGroup: {
    styleOverrides: {
      root: {
        borderRadius: 8
      }
    }
  },
  MuiToggleButton: {
    styleOverrides: {
      root: {
        borderRadius: 8
      }
    }
  }
}
export default ToggleButton